import * as React from "react";
import type { SVGProps } from "react";
const SvgBathroomIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#333"
      d="M9 1v3.912c.39-.068.79-.112 1.2-.112s.81.044 1.2.112V1zm1.2 4.6c-2.642 0-4.852 1.71-5.437 4h10.875c-.586-2.29-2.796-4-5.438-4m-6 4.8c-.66 0-1.2.54-1.2 1.2s.54 1.2 1.2 1.2h12c.66 0 1.2-.54 1.2-1.2s-.54-1.2-1.2-1.2zM7 14a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6m3.2 0a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6m3.2 0a.8.8 0 1 0-.001 1.599A.8.8 0 0 0 13.4 14m-8 3.2a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6m3.2 0a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6m3.2 0a.8.8 0 1 0-.001 1.599.8.8 0 0 0 .001-1.599m3.2 0a.8.8 0 1 0-.001 1.599A.8.8 0 0 0 15 17.2"
    />
  </svg>
);
export default SvgBathroomIcon;
